/**
 * @gongfu/memory
 * 智能记忆层，为 Gongfu 提供持久化、个性化的 AI 记忆能力
 */

// 核心客户端
export { MemoryClient } from './memory-client.js'

// 适配器
export { TaskMemoryAdapter } from './adapters/task-memory.js'
export { AgentMemoryAdapter } from './adapters/agent-memory.js'
export { UserPreferenceAdapter } from './adapters/user-preference.js'

// 类型定义
export type {
  // 基础类型
  MemoryEntry,
  MemoryMetadata,
  MemoryCategory,
  MemoryConfig,
  VectorStoreConfig,
  LLMConfig,
  EmbedderConfig,
  RetentionConfig,
  CapacityConfig,
  CacheConfig,
  EncryptionConfig,
  
  // 任务相关
  TaskMemory,
  TaskPattern,
  TaskOutcome,
  TaskSuggestion,
  
  // Agent 相关
  AgentMemory,
  AgentPerformance,
  PerformanceMetrics,
  CollaborationPattern,
  AgentFeedback,
  AgentUsage,
  AgentRecommendation,
  
  // 用户偏好相关
  UserPreference,
  PreferenceCategory,
  WorkPattern,
  PersonalizedSuggestion,
  
  // 搜索相关
  SearchOptions,
  SearchFilter,
  SearchResult,
  
  // 导入导出
  MemoryExport
} from './types/index.js'

// 工具函数
export * from './utils/memory-utils.js'

// 版本信息
export const VERSION = '0.1.0'

// 从类型中导入 MemoryConfig
import type { MemoryConfig } from './types/index.js'

// 默认配置
export const DEFAULT_CONFIG: Partial<MemoryConfig> = {
  config: {
    vector_store: {
      provider: 'qdrant',
      config: {
        collection_name: 'gongfu_memories',
        host: 'localhost',
        port: 6333
      }
    },
    llm: {
      provider: 'openai',
      config: {
        model: 'gpt-4o-mini',
        temperature: 0.1,
        max_tokens: 500
      }
    },
    embedder: {
      provider: 'openai',
      config: {
        model: 'text-embedding-3-small'
      }
    }
  }
}